export const SvgNotesCheckmark = ({ className }: { className: string }) => {
  return (
    <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M36 18c0 9.941-8.059 18-18 18S0 27.941 0 18 8.059 0 18 0s18 8.059 18 18Z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 33.5c8.56 0 15.5-6.94 15.5-15.5 0-8.56-6.94-15.5-15.5-15.5C9.44 2.5 2.5 9.44 2.5 18c0 8.56 6.94 15.5 15.5 15.5Zm0 2.5c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.378 12.822a1.1 1.1 0 0 1 0 1.556l-8.8 8.8a1.1 1.1 0 0 1-1.556 0l-4.4-4.4a1.1 1.1 0 1 1 1.556-1.556l3.622 3.622 8.022-8.022a1.1 1.1 0 0 1 1.556 0Z"
        fill="currentColor"
      />
    </svg>
  )
}
